import React, {useState } from 'react';
import { ExportActiveDocuments2 } from '../../../actions/ActiveDocumentActions';
const ExcelDownload = (props) => {
    const [formatDocumentIdAsLink, setFormatDocumentIdAsLink] = useState(true);

    const afterExcelDownload = () => {
      props.close();
    }

    const onExcelDownloadConfirmation = () => {
        let search = props.getSearch();
        const today = new Date();
        const yyyy = today.getFullYear();
        let mm = today.getMonth() + 1; // Months start at 0!
        let dd = today.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        const formattedToday = mm + '-' + dd + '-' + yyyy;

        let downloadName =
        props.mode +
        '_' +
        //firstDoc.stepName +
        //'_' +
        formattedToday +
        '.xlsx';

        console.log(props.formTypeId);
        ExportActiveDocuments2(search, formatDocumentIdAsLink, downloadName, props.formTypeId, afterExcelDownload);

    }

    return (
        <div className='td-dialogue-container'>
            <div
              className='td-dialogue card'
              style={{ height: '220px', width: '400px' }}
            >
              <div className='card-header'>
                Excel
                <button
                  onClick={props.close}
                  className='btn-close'
                />
              </div>
              <div className='card-body'>
                <div className='form-check  mt-2'>
                  <input
                    className='form-check-input'
                    checked={formatDocumentIdAsLink}
                    onChange={() => setFormatDocumentIdAsLink(!formatDocumentIdAsLink)}
                    type='checkbox'
                  />
                  <label className='form-check-label'>
                    Format Document Id as TrinDocs Link
                  </label>
                </div>
                <button
                  onClick={() =>
                    onExcelDownloadConfirmation(formatDocumentIdAsLink)

                  }
                  className='btn btn-success mt-3 w-100'
                >
                  Export to Excel
                </button>
              </div>
            </div>
          </div>
    )
}

export default ExcelDownload;